/* eslint-disable */
import Vue from "vue";
import { attachAuth0Retry } from "./auth0Refresh401";
import axios from "axios";
import VueAxios from "vue-axios";
import { getInstance } from "../auth0-plugin";
import { viewAsRoleHeaderValue } from "@/utils/viewAsRole";

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE || "/";

const API_URL = process.env.VUE_APP_API_ROOT_V2 || "/api/v2";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

axiosInstance.interceptors.request.use(async (config) => {
  const auth0 = await getInstance()

  let accessToken = null
  if (auth0 && auth0.isLoading) {
    await new Promise(resolve => {
      const interval = setInterval(() => {
        if (!auth0.isLoading) {
          clearInterval(interval);
          resolve();
        }
      }, 1);
    });
  }

  accessToken = await auth0.getAccessTokenSilently()

  config.method.toUpperCase();
  const viewAsRole = config?.skipViewAsRole ? null : viewAsRoleHeaderValue()
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${accessToken}`,
    ...(viewAsRole ? { 'X-View-As-Role': viewAsRole } : {}),
  }
  return config
},
error => {
  return Promise.reject(error)
}
)

axiosInstance.interceptors.response.use(
  function(response) {
    if (response.headers["access-token"]) {
      const token = [
        response.headers["token-type"],
        response.headers["access-token"],
        response.headers.client,
        response.headers.uid,
        response.headers.expiry
      ].join("|");
      localStorage.auth_token_default = token;
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

attachAuth0Retry(axiosInstance);

export default { axiosInstance };